import { ContainedIcon } from '@frontend/icons';

export const ScheduleCanceled = ({ as = 'span' }: { as?: React.ElementType }) => {
  return (
    <ContainedIcon
      as={as}
      css={{
        padding: 1,
        borderRadius: 'var(--fabric-radius-sm)',
      }}
      iconName='calendar-canceled'
      color={'var(--fabric-color-red-50)'}
    />
  );
};
